module.exports = __webpack_public_path__ + "static/media/oslo-1.6bd883fe.svg";